"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
var Map = /** @class */ (function () {
    function Map(coords) {
        if (coords.lat && coords.lng) {
            this.render(coords);
        }
    }
    Map.prototype.render = function (coordinates) {
        if (!google) {
            alert('Could not load maps library - please try again later!');
            return;
        }
        var map = new google.maps.Map(document.getElementById('map'), {
            center: coordinates,
            zoom: 16
        });
        new google.maps.Marker({
            position: coordinates,
            map: map
        });
    };
    return Map;
}());
exports.Map = Map;
